<template>
  <ul class="breadcrumb-menu">
    <li
      class="breadcrumb-menu-item"
      v-for="menu in menus"
      :key="menu.path"
      :class="{ 'is-current': currentPath === menu.path }"
    >
      <a v-bind:href="menu.path">{{ menu.name }}</a>
    </li>
  </ul>
</template>

<script>
import Menus from "@/mixins/irMenus.js";

export default {
  mixins: [Menus],
  computed: {
    currentPath() {
      return "/ir" + this.$route.path;
    },
    menus() {
      return this.irTop.concat(this.irMenus);
    },
  },
};
</script>
